import { render, staticRenderFns } from "./goods-editor.vue?vue&type=template&id=4c680343&"
import script from "./goods-editor.vue?vue&type=script&lang=js&"
export * from "./goods-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports